import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(utc);
dayjs.extend(isoWeek);

export type Range = { start: string; end: string };

export function getDateRanges(filters: string[], customRange?: { start: string; end: string }): Range[] {
  const now = dayjs();
  const ranges: Range[] = [];

  filters.forEach(filter => {
    switch (filter) {
      case "today": {
        const start = now.startOf("day");
        const end = now.endOf("day");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "tomorrow": {
        const start = now.add(1, "day").startOf("day");
        const end = now.add(1, "day").endOf("day");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "this-week": {
        const start = now.startOf("isoWeek"); // Monday–Sunday
        const end = now.endOf("isoWeek");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "next-week": {
        const start = now.add(1, "week").startOf("isoWeek");
        const end = now.add(1, "week").endOf("isoWeek");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "this-month": {
        const start = now.startOf("month");
        const end = now.endOf("month");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "next-month": {
        const start = now.add(1, "month").startOf("month");
        const end = now.add(1, "month").endOf("month");
        ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        break;
      }
      case "date-range": {
        if (customRange?.start && customRange?.end) {
          const start = dayjs(customRange.start).startOf("day");
          const end = dayjs(customRange.end).endOf("day");
          ranges.push({ start: start.utc().toISOString(), end: end.utc().toISOString() });
        }
        break;
      }
    }
  });

  return ranges;
}